(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["buscador-ia"] && !Shopify.designMode) return;
  try {
    (function() {
    const STORE_DOMAIN = 'lajugueteriadeadultos.com';
    const PRECIO_MAX_GLOBAL = 20000;
    const CACHE_KEY = 'fs-tendencias-ljda-v1';
    const CACHE_DIAS = 5;
    const RANGOS_KEY = 'fs-rangos-ljda-v1';
    const RANGOS_HORAS = 24;
    const MAX_PRODUCTS_SCAN = 250;
    const WA_NUMBER = '526674954155';

    const TENDENCIAS_FALLBACK = [
      { label: 'Vibrador',     handle: 'vibradores' },
      { label: 'Succionador',  handle: 'masajeadores-y-succionadores' },
      { label: 'Dildo',        handle: 'dildos-realistas' },
      { label: 'Lubricante',   handle: 'lubricantes-base-agua' },
      { label: 'Para pareja',  handle: 'juguetes-sexuales-para-parejas' },
      { label: 'Kit regalo',   handle: 'kits-de-juguetes-sexuales' },
      { label: 'BDSM',         handle: 'coleccion-bdsm' },
      { label: 'Anillo',       handle: 'anillos-de-contencion' }
    ];

    const TERMINOS_MAP = {
      'vibrador': 'vibradores', 'vibradores': 'vibradores',
      'succionador': 'masajeadores-y-succionadores', 'succionadores': 'masajeadores-y-succionadores',
      'masajeador': 'masajeadores-y-succionadores',
      'dildo': 'dildos-realistas', 'dildos': 'dildos-realistas', 'consolador': 'dildos-realistas',
      'lubricante': 'lubricantes-base-agua', 'lubricantes': 'lubricantes-base-agua',
      'pareja': 'juguetes-sexuales-para-parejas', 'parejas': 'juguetes-sexuales-para-parejas',
      'regalo': 'kits-de-juguetes-sexuales', 'kit': 'kits-de-juguetes-sexuales', 'kits': 'kits-de-juguetes-sexuales',
      'bdsm': 'coleccion-bdsm', 'bondage': 'coleccion-bdsm',
      'masturbador': 'masturbadores', 'masturbadores': 'masturbadores',
      'anillo': 'anillos-de-contencion', 'anillos': 'anillos-de-contencion',
      'plug': 'plugs-anales', 'plugs': 'plugs-anales', 'anal': 'juguetes-anales',
      'clitoris': 'vibradores-estimulantes-de-clitoris', 'clítoris': 'vibradores-estimulantes-de-clitoris',
      'punto g': 'vibradores-estimulantes-del-punto-g',
      'lenceria': 'lenceria-erotica', 'lencería': 'lenceria-erotica',
      'arnes': 'arneses', 'arnés': 'arneses',
      'control remoto': 'juguetes-sexuales-a-control-remoto',
      'wifi': 'juguetes-sexuales-controlados-por-wi-fi',
      'principiante': 'mi-primer-sex-toy', 'principiantes': 'mi-primer-sex-toy',
      'bestseller': 'mas-vendidos', 'mas vendido': 'mas-vendidos'
    };

    const PLACER = {
      'para-ella': [
        { label: 'Vibración',    col: 'vibradores-estimulantes-de-clitoris' },
        { label: 'Succión',      col: 'masajeadores-y-succionadores' },
        { label: 'Punto G',      col: 'vibradores-estimulantes-del-punto-g' },
        { label: 'Penetración',  col: 'dildos-realistas' },
        { label: 'Anal',         col: 'juguetes-anales' },
        { label: 'Lubricantes',  col: 'lubricantes-base-agua' }
      ],
      'para-el': [
        { label: 'Masturbación', col: 'masturbadores' },
        { label: 'Anillo',       col: 'anillos-de-contencion' },
        { label: 'Próstata',     col: 'vibradores-prostaticos' },
        { label: 'Bomba',        col: 'bombas-para-pene' },
        { label: 'Anal',         col: 'plugs-anales' },
        { label: 'Lubricantes',  col: 'lubricantes-base-agua' }
      ],
      'en-pareja': [
        { label: 'Control remoto', col: 'juguetes-sexuales-a-control-remoto' },
        { label: 'Wi-Fi',          col: 'juguetes-sexuales-controlados-por-wi-fi' },
        { label: 'BDSM',           col: 'coleccion-bdsm' },
        { label: 'Lencería',       col: 'lenceria-erotica' },
        { label: 'Juegos',         col: 'juegos-de-mesa-eroticos' },
        { label: 'Comestibles',    col: 'comestibles-eroticos' }
      ]
    };

    let precioMin = 0;
    let precioMax = PRECIO_MAX_GLOBAL;
    let colActual = 'mas-vendidos';
    let queryActual = '';
    let modoActual = 'coleccion';
    let debounce = null;
    let lastFocused = null;

    let sliderLimMin = 0;
    let sliderLimMax = PRECIO_MAX_GLOBAL;
    let productosFueraRango = 0;

    function fsGetCacheRangos() {
      try {
        const raw = localStorage.getItem(RANGOS_KEY);
        if (!raw) return {};
        const data = JSON.parse(raw);
        const expirado = (Date.now() - (data.ts || 0)) / (1000 * 60 * 60) > RANGOS_HORAS;
        if (expirado) return {};
        return data.rangos || {};
      } catch(e) { return {}; }
    }

    function fsSetCacheRangos(rangos) {
      try {
        localStorage.setItem(RANGOS_KEY, JSON.stringify({ rangos: rangos, ts: Date.now() }));
      } catch(e) {}
    }

    async function fsDetectarRango(handle) {
      const cache = fsGetCacheRangos();
      if (cache[handle]) return cache[handle];
      try {
        const r = await fetch('/collections/' + handle + '/products.json?limit=' + MAX_PRODUCTS_SCAN);
        const d = await r.json();
        const prods = d.products || [];
        if (!prods.length) return { min: 0, max: PRECIO_MAX_GLOBAL, fueraRango: 0, total: 0 };
        let minP = Infinity, maxP = 0, fueraRango = 0;
        prods.forEach(function(p) {
          if (!p.variants || !p.variants[0]) return;
          const precio = parseFloat(p.variants[0].price);
          if (isNaN(precio) || precio <= 0) return;
          if (precio < minP) minP = precio;
          if (precio > maxP) maxP = precio;
          if (precio > PRECIO_MAX_GLOBAL) fueraRango++;
        });
        if (minP === Infinity) minP = 0;
        const minRedondeado = Math.floor(minP / 50) * 50;
        const maxReal = Math.ceil(maxP / 50) * 50;
        const maxLim = Math.min(maxReal, PRECIO_MAX_GLOBAL);
        const rango = { min: minRedondeado, max: maxLim, maxReal: maxReal, fueraRango: fueraRango, total: prods.length };
        cache[handle] = rango;
        fsSetCacheRangos(cache);
        return rango;
      } catch(e) {
        return { min: 0, max: PRECIO_MAX_GLOBAL, fueraRango: 0, total: 0 };
      }
    }

    async function fsCargarTendencias() {
      try {
        const cached = localStorage.getItem(CACHE_KEY);
        if (cached) {
          const data = JSON.parse(cached);
          const diasPasados = (Date.now() - data.ts) / (1000 * 60 * 60 * 24);
          if (diasPasados < CACHE_DIAS && data.tags && data.tags.length > 0) {
            fsRenderTags(data.tags);
            return;
          }
        }
      } catch(e) {}
      try {
        const terminos = ['vibrador','succionador','dildo','lubricante','masturbador','anal','bdsm','anillo','lencería','kit'];
        const resultados = await Promise.all(terminos.map(async function(t) {
          try {
            const r = await fetch('/search/suggest.json?q=' + encodeURIComponent(t) + '&resources[type]=product&resources[limit]=3');
            const d = await r.json();
            return { termino: t, count: (d.resources && d.resources.results && d.resources.results.products || []).length };
          } catch(e) { return { termino: t, count: 0 }; }
        }));
        const top = resultados
          .filter(function(r){ return r.count > 0; })
          .sort(function(a,b){ return b.count - a.count; })
          .slice(0, 8)
          .map(function(r) {
            const handle = TERMINOS_MAP[r.termino] || 'mas-vendidos';
            const label = r.termino.charAt(0).toUpperCase() + r.termino.slice(1);
            return { label: label, handle: handle };
          });
        const tags = top.length >= 4 ? top : TENDENCIAS_FALLBACK;
        try { localStorage.setItem(CACHE_KEY, JSON.stringify({ tags: tags, ts: Date.now() })); } catch(e) {}
        fsRenderTags(tags);
      } catch(e) {
        fsRenderTags(TENDENCIAS_FALLBACK);
      }
    }

    function fsRenderTags(tags) {
      const row = document.getElementById('fs-tags-row');
      if (!row) return;
      row.innerHTML = tags.map(function(t, i) {
        return '<span class="fs-tag' + (i === 0 ? ' active' : '') + '" role="listitem" tabindex="0" onclick="fsTag(\'' + t.handle + '\', this)">' + t.label + '</span>';
      }).join('');
      if (tags.length > 0) colActual = tags[0].handle;
    }

    const PRECIO_GAP = 100;
    const sliderMin = document.getElementById('fs-slider-min');
    const sliderMax = document.getElementById('fs-slider-max');
    const sliderRange = document.getElementById('fs-slider-range');
    const labelMin = document.getElementById('fs-precio-min-label');
    const labelMax = document.getElementById('fs-precio-max-label');
    const precioAviso = document.getElementById('fs-precio-aviso');

    function fsUpdateSliderUI() {
      const min = parseInt(sliderMin.value);
      const max = parseInt(sliderMax.value);
      const rango = (sliderLimMax - sliderLimMin) || 1;
      const pctMin = ((min - sliderLimMin) / rango) * 100;
      const pctMax = ((max - sliderLimMin) / rango) * 100;
      sliderRange.style.left = Math.max(0, pctMin) + '%';
      sliderRange.style.right = Math.max(0, 100 - pctMax) + '%';
      labelMin.textContent = '$' + min.toLocaleString('es-MX') + ' MXN';
      labelMax.textContent = '$' + max.toLocaleString('es-MX') + (max >= PRECIO_MAX_GLOBAL ? '+ MXN' : ' MXN');
    }

    function fsAplicarLimitesSlider(lim) {
      sliderLimMin = lim.min;
      sliderLimMax = lim.max;
      productosFueraRango = lim.fueraRango || 0;
      sliderMin.min = lim.min; sliderMin.max = lim.max; sliderMin.value = lim.min;
      sliderMax.min = lim.min; sliderMax.max = lim.max; sliderMax.value = lim.max;
      precioMin = lim.min;
      precioMax = lim.max;
      fsUpdateSliderUI();
      fsRenderAvisoRango();
    }

    function fsRenderAvisoRango() {
      if (!precioAviso) return;
      if (productosFueraRango > 0 && modoActual === 'coleccion') {
        const plural = productosFueraRango === 1 ? 'producto' : 'productos';
        precioAviso.innerHTML = 'Hay ' + productosFueraRango + ' ' + plural +
          ' arriba de $' + PRECIO_MAX_GLOBAL.toLocaleString('es-MX') +
          '. <a id="fs-aviso-link" tabindex="0">Ver todos →</a>';
        const link = document.getElementById('fs-aviso-link');
        if (link) {
          link.addEventListener('click', function(e) {
            e.preventDefault();
            window.location.href = '/collections/' + colActual + '?filter.v.price.gte=' + PRECIO_MAX_GLOBAL;
            fsClose();
          });
        }
      } else {
        precioAviso.innerHTML = '';
      }
    }

    sliderMin.addEventListener('input', function() {
      let min = parseInt(sliderMin.value);
      let max = parseInt(sliderMax.value);
      if (max - min < PRECIO_GAP) { min = max - PRECIO_GAP; if (min < sliderLimMin) min = sliderLimMin; sliderMin.value = min; }
      precioMin = min;
      fsUpdateSliderUI();
      fsDebounceFiltrar();
    });

    sliderMax.addEventListener('input', function() {
      let min = parseInt(sliderMin.value);
      let max = parseInt(sliderMax.value);
      if (max - min < PRECIO_GAP) { max = min + PRECIO_GAP; if (max > sliderLimMax) max = sliderLimMax; sliderMax.value = max; }
      precioMax = max;
      fsUpdateSliderUI();
      fsDebounceFiltrar();
    });

    let filtroDebounce = null;
    function fsDebounceFiltrar() {
      clearTimeout(filtroDebounce);
      filtroDebounce = setTimeout(fsFiltrarPorPrecio, 250);
    }

    fsUpdateSliderUI();

    async function fsCargar(handle, limit) {
      try {
        const r = await fetch('/collections/' + handle + '/products.json?limit=' + (limit || 8));
        const d = await r.json();
        return d.products || [];
      } catch(e) { return []; }
    }

    async function fsSearchNativo(q) {
      try {
        const r = await fetch('/search/suggest.json?q=' + encodeURIComponent(q) + '&resources[type]=product&resources[limit]=8');
        const d = await r.json();
        const raw = (d.resources && d.resources.results && d.resources.results.products) || [];
        return raw.map(function(p) {
          const imgUrl = p.featured_image ? (p.featured_image.url || p.featured_image) : (p.image || null);
          const precio = p.price ? parseFloat(p.price) : 0;
          const compare = p.compare_at_price_max ? parseFloat(p.compare_at_price_max) : null;
          return {
            title: p.title, handle: p.handle,
            url: p.url || ('/products/' + p.handle),
            images: imgUrl ? [{ src: imgUrl }] : [],
            variants: [{ price: precio.toString(), compare_at_price: (compare && compare > precio) ? compare.toString() : null }]
          };
        });
      } catch(e) { return []; }
    }

    function fsFiltrarPrecio(p) {
      if (modoActual === 'busqueda') return true;
      const precio = p.variants && p.variants[0] ? parseFloat(p.variants[0].price) : 0;
      return precio >= precioMin && precio <= precioMax;
    }

    function fsActualizarVerTodos() {
      const wrap = document.getElementById('fs-ver-todos');
      const link = document.getElementById('fs-ver-todos-link');
      const waLink = document.getElementById('fs-wa-link');
      if (!wrap || !link) return;

      const params = new URLSearchParams();
      let waMsg = '';

      if (modoActual === 'busqueda' && queryActual) {
        params.set('q', queryActual);
        link.href = '/search?' + params.toString();
        link.textContent = 'Ver todos los resultados →';
        waMsg = 'Hola! Busco: ' + queryActual;
      } else if (modoActual === 'coleccion' && colActual) {
        if (precioMin > sliderLimMin) params.set('filter.v.price.gte', precioMin);
        if (precioMax < sliderLimMax) params.set('filter.v.price.lte', precioMax);
        const qs = params.toString();
        link.href = '/collections/' + colActual + (qs ? '?' + qs : '');
        link.textContent = 'Ver todos los productos →';
        waMsg = 'Hola! Me interesa la categoría: ' + colActual.replace(/-/g, ' ');
      }

      if (waLink) {
        waLink.href = 'https://wa.me/' + WA_NUMBER + (waMsg ? '?text=' + encodeURIComponent(waMsg) : '');
      }

      wrap.style.display = 'flex';
    }

    async function fsFiltrarPorPrecio() {
      const grid = document.getElementById('fs-grid');
      fsSkel(grid);
      if (modoActual === 'busqueda' && queryActual) {
        const prods = await fsSearchNativo(queryActual);
        fsRender(prods.filter(fsFiltrarPrecio).slice(0, 8), grid);
      } else {
        const prods = await fsCargar(colActual, 50);
        fsRender(prods.filter(fsFiltrarPrecio).slice(0, 8), grid);
      }
      fsActualizarVerTodos();
    }

    function fsRender(prods, container) {
      if (!container) return;
      if (!prods || !prods.length) {
        container.innerHTML = '<div class="fs-empty"><div class="fs-empty-emoji">🔍</div><p class="fs-empty-title">No encontramos productos</p><p class="fs-empty-sub">Ajusta el precio o intenta con otro término.</p></div>';
        return;
      }
      container.innerHTML = prods.slice(0, 8).map(function(p) {
        const precio = p.variants ? parseFloat(p.variants[0].price) : (p.price ? parseFloat(p.price) / 100 : 0);
        const anterior = p.variants && p.variants[0].compare_at_price ? parseFloat(p.variants[0].compare_at_price) : null;
        const img = (p.images && p.images[0]) ? (p.images[0].src || p.images[0]) : (p.image || (p.featured_image ? p.featured_image : null));
        const url = p.url || ('/products/' + p.handle);
        const oferta = anterior && anterior > precio;
        const titulo = (p.title || '').replace(/"/g, '&quot;');
        return '<a href="' + url + '" class="fs-card" onclick="fsClose()" aria-label="' + titulo + '">'
          + (oferta ? '<span class="fs-badge">Oferta</span>' : '')
          + (img ? '<img class="fs-card-img" src="' + img + '" alt="' + titulo + '" loading="lazy" width="200" height="200">' : '<div class="fs-card-img-placeholder">🛍</div>')
          + '<div class="fs-card-info"><p class="fs-card-name">' + titulo + '</p>'
          + '<div class="fs-card-prices"><span class="fs-card-price">$' + precio.toLocaleString('es-MX') + '</span>'
          + (oferta ? '<span class="fs-card-old">$' + anterior.toLocaleString('es-MX') + '</span>' : '')
          + '</div></div></a>';
      }).join('');
    }

    function fsSkel(container, n) {
      if (!container) return;
      container.innerHTML = Array(n || 8).fill('<div class="fs-skel"><div class="fs-skel-img"></div><div class="fs-skel-line"></div><div class="fs-skel-price"></div></div>').join('');
    }

    window.fsTag = async function(handle, el) {
      document.querySelectorAll('.fs-tag').forEach(function(t){ t.classList.remove('active'); });
      el.classList.add('active');
      colActual = handle;
      modoActual = 'coleccion';
      queryActual = '';
      document.getElementById('fs-grid-label').textContent = el.textContent;
      const grid = document.getElementById('fs-grid');
      fsSkel(grid);
      const [lim, prods] = await Promise.all([fsDetectarRango(handle), fsCargar(handle, 50)]);
      fsAplicarLimitesSlider(lim);
      fsRender(prods.filter(fsFiltrarPrecio).slice(0, 8), grid);
      fsActualizarVerTodos();
    };

    document.getElementById('fs-input').addEventListener('input', function() {
      const q = this.value.trim();
      clearTimeout(debounce);
      if (q.length < 2) {
        modoActual = 'coleccion';
        queryActual = '';
        fsCargarPopulares();
        return;
      }
      debounce = setTimeout(async function() {
        modoActual = 'busqueda';
        queryActual = q;
        sliderLimMin = 0; sliderLimMax = PRECIO_MAX_GLOBAL;
        sliderMin.min = 0; sliderMin.max = PRECIO_MAX_GLOBAL;
        sliderMax.min = 0; sliderMax.max = PRECIO_MAX_GLOBAL;
        precioMin = 0; precioMax = PRECIO_MAX_GLOBAL;
        sliderMin.value = 0; sliderMax.value = PRECIO_MAX_GLOBAL;
        fsUpdateSliderUI();
        productosFueraRango = 0;
        fsRenderAvisoRango();
        document.getElementById('fs-grid-label').textContent = 'Resultados para "' + q + '"';
        const grid = document.getElementById('fs-grid');
        fsSkel(grid);
        const prods = await fsSearchNativo(q);
        fsRender(prods.filter(fsFiltrarPrecio).slice(0, 8), grid);
        fsActualizarVerTodos();
        productosFueraRango = 0;
        fsRenderAvisoRango();
      }, 350);
    });

    document.getElementById('fs-input').addEventListener('keydown', function(e) {
      if (e.key === 'Enter' && this.value.trim()) {
        window.location.href = '/search?q=' + encodeURIComponent(this.value.trim());
        fsClose();
      }
    });

    async function fsCargarPopulares() {
      document.getElementById('fs-grid-label').textContent = 'Más vendidos';
      const grid = document.getElementById('fs-grid');
      fsSkel(grid);
      const [lim, prods] = await Promise.all([fsDetectarRango(colActual), fsCargar(colActual, 50)]);
      fsAplicarLimitesSlider(lim);
      fsRender(prods.filter(fsFiltrarPrecio).slice(0, 8), grid);
      fsActualizarVerTodos();
    }

    window.fsGuiaOpen = function() {
      document.getElementById('fs-main-view').style.display = 'none';
      document.getElementById('fs-guia-view').classList.add('active');
    };

    window.fsGuiaClose = function() {
      document.getElementById('fs-main-view').style.display = 'block';
      document.getElementById('fs-guia-view').classList.remove('active');
    };

    window.fsGuiaReset = function() {
      document.getElementById('fs-g1').style.display = 'block';
      document.getElementById('fs-g2').style.display = 'none';
      document.getElementById('fs-g3').style.display = 'none';
      const verWrap = document.getElementById('fs-guia-ver-todos');
      if (verWrap) verWrap.style.display = 'none';
      document.querySelectorAll('.fs-chip').forEach(function(c){ c.classList.remove('sel'); });
      document.getElementById('fs-content').scrollTop = 0;
    };

    window.fsG1 = function(genero, el) {
      document.querySelectorAll('#fs-g1 .fs-chip').forEach(function(c){ c.classList.remove('sel'); });
      el.classList.add('sel');
      document.getElementById('fs-g3').style.display = 'none';
      if (genero === 'regalo') {
        document.getElementById('fs-g2').style.display = 'none';
        fsG3('kits-de-juguetes-sexuales', 'Kits y regalos perfectos 🎁', 'Los mejores sets para sorprender');
        return;
      }
      if (genero === 'principiante') {
        document.getElementById('fs-g2').style.display = 'none';
        fsG3('mi-primer-sex-toy', 'Mi primer sex toy ✨', 'Productos ideales para empezar');
        return;
      }
      const ops = PLACER[genero] || [];
      document.getElementById('fs-chips-placer').innerHTML = ops.map(function(op) {
        return '<span class="fs-chip" tabindex="0" data-col="' + op.col + '" data-label="' + op.label + '" onclick="fsG2(this)">' + op.label + '</span>';
      }).join('');
      document.getElementById('fs-g2').style.display = 'block';
      setTimeout(function() {
        document.getElementById('fs-g2').scrollIntoView({ behavior: 'smooth', block: 'nearest' });
      }, 100);
    };

    window.fsG2 = function(el) {
      document.querySelectorAll('#fs-g2 .fs-chip').forEach(function(c){ c.classList.remove('sel'); });
      el.classList.add('sel');
      fsG3(el.dataset.col, 'Eva te recomienda ✨', 'Basado en tu selección: ' + el.dataset.label);
    };

    async function fsG3(col, titulo, sub) {
      document.getElementById('fs-g3').style.display = 'block';
      document.getElementById('fs-g3-titulo').textContent = titulo;
      document.getElementById('fs-g3-sub').textContent = sub;
      const grid = document.getElementById('fs-guia-grid');
      fsSkel(grid);
      fsRender(await fsCargar(col, 8), grid);
      const verWrap = document.getElementById('fs-guia-ver-todos');
      const verLink = document.getElementById('fs-guia-ver-todos-link');
      if (verWrap && verLink) {
        verLink.href = '/collections/' + col;
        verWrap.style.display = 'block';
      }
      setTimeout(function() {
        document.getElementById('fs-g3').scrollIntoView({ behavior: 'smooth', block: 'nearest' });
      }, 100);
    }

    window.fsSearchOpen = function() {
      lastFocused = document.activeElement;
      const overlay = document.getElementById('fs-overlay');
      overlay.classList.add('open');
      overlay.setAttribute('aria-hidden', 'false');
      document.body.style.overflow = 'hidden';
      setTimeout(function(){
        const input = document.getElementById('fs-input');
        if (input) input.focus();
      }, 280);
      fsCargarTendencias();
      fsCargarPopulares();
    };

    window.fsClose = function() {
      const overlay = document.getElementById('fs-overlay');
      overlay.classList.remove('open');
      overlay.setAttribute('aria-hidden', 'true');
      document.body.style.overflow = '';
      document.getElementById('fs-input').value = '';
      window.fsGuiaClose();
      window.fsGuiaReset();
      if (lastFocused && lastFocused.focus) {
        try { lastFocused.focus(); } catch(e) {}
      }
    };

    document.getElementById('fs-overlay').addEventListener('click', function(e) {
      if (e.target === this) window.fsClose();
    });

    document.addEventListener('keydown', function(e){
      if (e.key === 'Escape' && document.getElementById('fs-overlay').classList.contains('open')) {
        window.fsClose();
      }
    });
  })();
  } catch(e) { console.error(e); }
})();

})();
